<template>
  <div>
	<div class="menu-wrapper" ref="menu">
		<!-- -->
    <div v-if="menuLogo">
      <a href="/"><img src="@/assets/img/logo311_w1.png" style="height: 75px; margin: 50px auto 40px; display: block;"></a>
    </div>
    <div class="menu-list">
      <el-menu :mode="mode" router unique-opened :default-active="$route.path" :background-color="background" :text-color="textcolor"
               :active-text-color="activecolor" :collapse="isCollapse" >

        <template v-for="(item,i) in routes" v-if="!item.hidden">
          <!-- v-if="!item.children||(item.children.length===1 && !item.children[0].children && !item.alwaysShow)" -->
          <el-menu-item :class="{'submenu-title-noDropdown':!isNest}" :key="i+1" :index="level1Menu(item)" :disabled=' item.path=="disabled"? true:false'
                        v-if="(!item.children||(item.children.length===1 && !item.children[0].children))&& (menuTop==false||(menuTop==true &&  item.componentName!='left'))">
            <!-- disabled -->
            <span v-if="item.children">{{item.children[0].title}}</span>
            <span v-else>{{ item.title}}</span>
          </el-menu-item>
          <!-- item.name||item.path -->
          <el-submenu v-else-if="(menuTop==false||(menuTop==true &&  item.componentName!='left'))" :index="item.path" :key="i+1">
            <template slot="title">
              <span>{{item.title}}</span>
            </template>

            <template v-for="(child,j) in item.children" v-if="!child.hidden">
              <!-- 	<sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]"
                 :key="child.path"></sidebar-item> v-else-->
              <el-menu-item  :index="level2Menu(child,item.path)" :key="j">
                <span style="font-family:'microsoft yahei', Verdana, Arial, Tahoma!important;">{{child.title}}</span>
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
      </el-menu>
    </div>
	</div>
  </div>
</template>

<script>
	export default {
		props: {
			isNest: {
				type: Boolean,
				default: false
			},
			mode: {
				type: String,
				default: "vertical"
			},
			background: {
				type: String,
				default: "" //#304156
			},
			textcolor: {
				type: String,
				default: "" //#fff
			},
			activecolor: {
				type: String,
				default: "" //#409EFF
			},
			collapsetransition: {
				type: Boolean,
				default: true
			},
			isCollapse: {
				type: Boolean,
				default: false
			},
			device: { //isMobile
				type: String,
				default: 'desktop'
			},
			menuLogo: {
				type: Boolean,
				default: false
			},
			menuTop: {//当前是头部导航 ，不是左导航调用
				type: Boolean,
				default: false
			},
		},
		computed: {
			routes() {
				return global.antRouter
			}
		},
		data() {
			return {
				activeIndex: ""
			}
		},
		mounted(){
			console.log(this.$route.path)
		},
    methods: {
			level1Menu(item) {
				if (item.redirect) {
					let PathParameter = item.redirect.split(":")
					if (PathParameter.length > 1) { //有参数
						return PathParameter[0] + item.id
					} else {
						return item.redirect
					}

				} else if (!item.children) { //不用layout框架 或 没有子导航
					return item.path
					//this.$router.push(item.path)
				} else {
					let childPathParameter = item.children[0].path.split(":")
					if (childPathParameter.length > 1) { //有参数
						return item.path + '/' + childPathParameter[0] + item.children[0].id
						//this.$router.push(item.path + '/' + childPathParameter[0] + item.id)
					} else {
						return item.path + '/' + item.children[0].path
						//this.$router.push(item.path + '/' + item.children[0].path)
					}
				}
				//console.log("99");
			},
			level2Menu(item, upurl) {
				let url=""
				if (item.redirect) {
					let PathParameter = item.redirect.split(":")
					if (PathParameter.length > 1) { //有参数
						url= PathParameter[0] + item.id
					} else {
						url= item.redirect
					}
				} else {
					let PathParameter = item.path.split(":")
					if (PathParameter.length > 1) { //有参数
						url= upurl + '/' + PathParameter[0] + item.id
					} else {
						url=  upurl + '/' + item.path
					}
				}

				return url
			}
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/layout/components/sidebar/index.vue